export const radiusBarLeft = [50, 0, 0, 50]

export const radiusBarRight = [0, 50, 50, 0]

export const stackedColor1 = '#6366f1'
export const stackedColor2 = '#22c55e'
export const stackedColor3 = '#11165e'
